import { GENERATED_EMAIL_PATTERN } from 'constants/defaultConstants';

export const isGeneratedEmail = (email: string): boolean =>
  GENERATED_EMAIL_PATTERN.test(email);
